import styled from 'styled-components'

export const UpdateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const ImgLogo = styled.img`
  align-items: center;
  text-align: center;
  display: flex;
  width: 72px;
`

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const UpdateTitle = styled.h2`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`

export const UpdateDescription = styled.p`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`

export const StayButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 8px;
  background: var(--Background-Primary-faded, #edecfd);

  border: none;
  color: var(--Foreground-Primary, #4d4be7);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 160% */

  outline: none;
`

export const DownloadButton = styled.a`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  /* Raised */
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);

  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 6px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    var(--Foreground-Primary, #4d4be7);
  background-blend-mode: soft-light, normal;

  color: var(--On-background-Primary, #fff);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 160% */
  text-decoration: none;

  outline: none;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  gap: 12px;
`
